export default {
    phone: 1032
};
